import { render } from "./CompanyTextLogo.vue?vue&type=template&id=b0118bb8"
import script from "./CompanyTextLogo.vue?vue&type=script&lang=js"
export * from "./CompanyTextLogo.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/checkmarq-backend/checkmarq-backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__